'use client'
import { memo, type PropsWithChildren } from 'react'

const VaultActivityLayout = ({ children }: PropsWithChildren) => {
  return <div className="gap-lg sm:gap-xl flex w-full flex-col">{children}</div>
}

export default memo(VaultActivityLayout)
